import "./MenuScreen.css";

interface MathModeScreenProps {
  onSelectComputations: () => void;
  onSelectShapes: () => void;
  onSelectMaze: () => void;
  onBack: () => void;
}

export function MathModeScreen({
  onSelectComputations,
  onSelectShapes,
  onSelectMaze,
  onBack,
}: MathModeScreenProps) {
  return (
    <div className="MenuScreen">
      <div className="MenuCard">
        <button className="MenuBack" type="button" onClick={onBack}>
          Wstecz
        </button>
        <div className="MenuTitle">Matematyka</div>
        <div className="MenuSubtitle">Wybierz grę</div>
        <div className="MenuActions">
          <button
            className="MenuButton"
            type="button"
            onClick={onSelectComputations}
          >
            Działania — obliczenia
          </button>
          <button
            className="MenuButton is-secondary"
            type="button"
            onClick={onSelectShapes}
          >
            Kształty — rozpoznawanie
          </button>
          <button
            className="MenuButton is-secondary"
            type="button"
            onClick={onSelectMaze}
          >
            Labirynt — programowanie
          </button>
        </div>
      </div>
      <div className="MenuBackdrop" />
    </div>
  );
}
